// extracted by mini-css-extract-plugin
export default {"legend":"geoStyles_legend__x8jdO","legend2":"geoStyles_legend2__P58-I","tooltip":"geoStyles_tooltip__2Ieam","iconBtn":"geoStyles_iconBtn__96vpQ"};